import { render } from "./RadiologyQueueModal.vue?vue&type=template&id=40fe4cb0"
import script from "./RadiologyQueueModal.vue?vue&type=script&lang=js"
export * from "./RadiologyQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__